import InitPage from './pages/initialPage';
import LandingPage from './pages/landingPage';
import ProloguePage from './pages/prologuePage';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import UpdateLogPage from './pages/updateLogPage';
import AboutUS from './pages/aboutUs';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RedirectingPage from './pages/redirectingPage';
import TwichToolPage from './pages/twichToolPage';
import Novel from './pages/novel';
import Testimonials from './pages/testimonials';
import VideoPage from './pages/videoPage';
import PrivacyPage from './pages/privacy';
import ArtPage from './pages/artPage';
import LoginModal from './components/modal/login';
import RegisterPage from './pages/register';
import TermsPage from './pages/terms';
import Marketplace from './pages/marketplace';
import Profile from './pages/profile';
import ForgetPassword from './pages/forgetPassword';
import Admin from './pages/admin';
import AdminLogin from './pages/adminlogin';
import ManageUser from './pages/manageuser';
import AllPage from './pages/all';
import UserProfile from './pages/profile';
import AdminRegister from './pages/adminregister';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from './state/hooks';
import { api } from './api/api';
import { loginSuccess } from './state/auth';
import AccountView from './pages/accountView';
import ItemView from './pages/itemView';
import BoostingView from './pages/boostingView';
import AdminRoute from './components/AdminRoute';
import AdminProfile from './pages/adminprofile';
import AdminAssetsView from './pages/adminassetsview';
import ManageTwitchMarketors from './pages/managetwitchmarketors';
import ManageGiveaway from './pages/managegiveaway';
import AdminBoostingView from './pages/adminboostingview';
import ManageWinners from './pages/managewinners';
import MailSMTP from './pages/mailsmtp';
import PartnerLogin from './pages/partnerlogin';
import PartnerRegister from './pages/partnerregister';
import PartnerProfile from './pages/partnerprofile';
import PartnerDash from './pages/partnerdash';
import GiveawayRedeemPage from './pages/giveaway-redeem';
import RewardClaimPage from './pages/reward-claim';
import RedeemClaimPage from './pages/RedeemClaimPage';
import JgProfilePage from './pages/profile/jg';
import Verify2faPage from './pages/verify2fa';


function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useAppSelector((state) => state.authSlice);

  useEffect(() => {
    if (isLoggedIn) {
      const checkReward = async () => {
        try {
          const response = await api.get('/api/giveaways/check-reward');
          if (response.data.rewardId) {
            navigate('/reward-claim', { state: { rewardId: response.data.rewardId } });
          }
        } catch (error) {
          console.error('Error checking for rewards:', error);
        }
      };
      checkReward();
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const name = params.get('name');
    const email = params.get('email');

    const otpauthUrl = params.get('otpauthUrl');

    if (token && name && email) {
      if (otpauthUrl) {
        navigate('/verify-2fa', { state: { email, name, otpauthUrl } });
      } else {
        localStorage.setItem('token', token);
        sessionStorage.setItem('email', email);
        dispatch(loginSuccess(name));
        navigate('/');
      }
    }
  }, [location, navigate, dispatch]);

  if (window.location.hostname === 'iplaymore.vercel.app') {
    window.location.href = 'https://iplaymore.com/';
  }

  return (
    <div className="flex">
      <ToastContainer />
      <LoginModal />
      {window.location.pathname !== '/subscribe' && <InitPage />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/prologue" element={<ProloguePage />} />
        <Route path="/twitch-tool" element={<TwichToolPage />} />
        <Route path="/novel" element={<Novel />} />
        <Route path="/update-logs" element={<UpdateLogPage />} />
        <Route path="/videos" element={<VideoPage />} />
        <Route path="/art-music" element={<ArtPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/iplaymore" element={<AboutUS />} />
        <Route path="/subscribe" element={<RedirectingPage />} />
        <Route path="/signup" element={<RegisterPage />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile-jg" element={<JgProfilePage />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<Admin />} />
          <Route path="/manageuser" element={<ManageUser />} />
          <Route path="/adminregister" element={<AdminRegister />} />
          <Route path="/admin/users/:id" element={<UserProfile />} />
          <Route path="/all" element={<AllPage />} />
          <Route path="/adminprofile" element={<AdminProfile />} />
          <Route path="/adminassetsview" element={<AdminAssetsView />} />
          <Route path="/adminboostingview" element={<AdminBoostingView />} />
          <Route path="/managegiveaway" element={<ManageGiveaway />} />
          <Route path="/managetwitchmarketors" element={<ManageTwitchMarketors />} />
          <Route path="/managewinners" element={<ManageWinners />} />
          <Route path="/mailsmtp" element={<MailSMTP />} />
          <Route path="/mailsmtp" element={<MailSMTP />} />
        </Route>
        <Route path="/accounts/:id" element={<AccountView />} />
        <Route path="/items/:id" element={<ItemView />} />
        <Route path="/boosting/:id" element={<BoostingView />} />
        <Route path="/partnerlogin" element={<PartnerLogin />} />
        <Route path="/partnerregister" element={<PartnerRegister />} />
        <Route path="/partnerprofile" element={<PartnerProfile />} />
        <Route path="/partnerdash" element={<PartnerDash />} />
        <Route path="/giveaway-redeem" element={<GiveawayRedeemPage />} />
        <Route path="/reward-claim" element={<RewardClaimPage />} />
        <Route path="/redeem-claim" element={<RedeemClaimPage />} />
        <Route path="/verify-2fa" element={<Verify2faPage />} />
      </Routes>
    </div>
  );
}

export default App;